export const gitCommitHash = 'c3e65f84d2994838782600700e2fd52b23240957'
